import * as React from "react";
import { SetStateAction, Dispatch, useState, useEffect } from "react";
import { PbrInputEmail } from "src/components/common/PbrInputEmail/PbrInputEmail";
import { Row, Col } from "antd";
import { PbrCard } from "src/components/common/PbrCard/PbrCard";
import { PbrInputPhone } from "src/components/common/PbrInputPhone/PbrInputPhone";
import { EditTradeOwnerPJ } from "./EditTradeOwnerPJ";
import { EditTradeOwnerPessoaFisica } from "./EditTradeOwnerPessoaFisica";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import { ITradeOwner } from "src/services/interfaces/trade/tradeOwner/ITradeOwner";
import { GetPersonType, PersonTypeEnum } from "src/util/GetPersonType";
import { FormComponentProps } from "antd/lib/form/Form";

interface IEditTradeOwner extends FormComponentProps {
  setLoading: Dispatch<SetStateAction<boolean>>;
  trade: ITrade;
  setTrade: Dispatch<SetStateAction<ITrade>>;
  title: string;
  isMotherNameRequired: boolean;
  isCivilStatusRequired: boolean;
  isProfessionRequired: boolean;
  isFatherNameRequired: boolean;
  isRGDateRequired: boolean;
  isIssuingAuthorityRequired: boolean;
}


export const EditTradeOwner: React.FC<IEditTradeOwner> = ({
  setLoading,
  trade,
  setTrade,
  title,
  form,
  isMotherNameRequired,
  isCivilStatusRequired,
  isProfessionRequired,
  isFatherNameRequired,
  isIssuingAuthorityRequired,
  isRGDateRequired
}) => {
  const [personType, setPersonType] = useState<PersonTypeEnum>(undefined);

  useEffect(() => {
    const type = GetPersonType(trade?.tradeOwner?.cpfCnpj);
    setPersonType(type);
  }, [trade.tradeOwner?.cpfCnpj]);

  const handleTradeOwnerChange = (value: Partial<ITradeOwner>) => {
    const tradeOwner = { ...trade.tradeOwner, ...value };

    setTrade({ ...trade, tradeOwner });
  };

  return (
    <PbrCard className="default-tabs" title={title} bordered={false} style={{ width: "100%" }}>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={12} lg={12}>
          <PbrInputEmail
            value={trade.tradeOwner?.login}
            onChange={e => handleTradeOwnerChange({ login: e.target.value })}
            formWrapper={form}
            name="Email"
            title="E-mail"
            formItemProps={{ label: "E-mail" }}
            placeholder="Digite o e-mail"
            required={true}
            isRequired
          />
        </Col>

        <Col xs={24} sm={24} md={12} lg={12}>
          <PbrInputPhone
            value={trade.tradeOwner?.phoneNumber}
            onChange={e => handleTradeOwnerChange({ phoneNumber: e.target.value })}
            name="phone"
            title="Celular"
            formItemProps={{ label: "Celular" }}
            formWrapper={form}
            rules={[{ required: true, message: "Informe o Número do Telefone" }]}
          />
        </Col>
      </Row>
      {personType === PersonTypeEnum.PJ ? (
        <EditTradeOwnerPJ onChange={handleTradeOwnerChange} currentTrade={trade} form={form} />
      ) : (
        <EditTradeOwnerPessoaFisica
          onChange={handleTradeOwnerChange}
          trade={trade}
          setTrade={setTrade}
          setLoading={setLoading}
          form={form}
          isFatherNameRequired={isFatherNameRequired}
          isProfessionRequired={isProfessionRequired}
          isCivilStatusRequired={isCivilStatusRequired}
          isMotherNameRequired={isMotherNameRequired}
          isIssuingAuthorityRequired={isIssuingAuthorityRequired}
          isRGDateRequired={isRGDateRequired}
        />
      )}
    </PbrCard>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/TradeEdit/EditTradeOwner/EditTradeOwner.tsx